import { defineMeta } from '@/registry/types';

export const chartMeta = defineMeta({
  name: 'Chart',
  level: 'organism',
  category: 'data-display',
  classification: 'third-party-wrapper',
  description:
    'Config-driven chart. Accepts a serialisable ChartConfig so user-built dashboards can persist and replay a chart definition. Typed per-type components (BarChart, LineChart, PieChart, ScatterChart, HeatmapChart, SankeyChart) are thin adapters over this.',
  baseLibrary: 'echarts',
  importPath: '@/charts',
  packageImport: '@aistrike-dev/ui/charts',
  requiredProps: ['config', 'data'],
  optionalProps: [
    'mode',
    'media',
    'height',
    'state',
    'onPointClick',
    'transformOption',
    'label',
    'decals',
  ],
  customVariants: ['screen', 'export'],
  supportedStates: ['default', 'loading', 'empty', 'error'],
  designTokens: ['chart', 'severity'],
  accessibility: [
    'ECharts aria description is enabled, giving screen readers a text equivalent of the plot.',
    'Decal textures are available via `decals` for a secondary encoding beyond hue, but are off by default — hue alone carries series identity unless enabled.',
    'A legend appears automatically for two or more series; a single series is named by the title instead.',
  ],
  usageExamples: [
    '<BarChart xKey="day" series={[{ key: "alerts", name: "Alerts" }]} data={rows} />',
    '<Chart config={savedConfig} data={rows} media="export" mode="light" />',
  ],
  antiPatterns: [
    'Do not use severity colours as a series palette — severity encodes status, not identity.',
    'Do not exceed three series in scatter or bubble forms; fold the tail into "Other" or facet.',
    'Never render two measures of different scale on two y-axes; use two charts or index to a common base.',
  ],
  llmSafe: true,
  whenToUse: ['Any multi-point data visualisation, on screen or in an exported report'],
  whenNotToUse: [
    'A single headline number (use StatTile)',
    'A row-level trend (use Sparkline)',
    'A tabular result set (use the Table organism)',
  ],
});

export default chartMeta;
